/**
 * Yummy Light Store — Customer Photo Upload
 * Uploads to Cloudinary (unsigned), stores URL as line item property
 */

(function () {
  // ── CONFIG ────────────────────────────────────────────────────────────────
  const CLOUD_NAME    = 'dzdsgcr6d';
  const UPLOAD_PRESET = 'yummy_uploads';
  const MAX_MB        = 10;
  // ──────────────────────────────────────────────────────────────────────────

  const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const fileInput   = document.getElementById('yummy-file-input');
    const filename    = document.getElementById('yummy-filename');
    const previewWrap = document.getElementById('yummy-preview-wrap');
    const previewImg  = document.getElementById('yummy-preview-img');
    const removeBtn   = document.getElementById('yummy-remove-btn');
    const photoUrl    = document.getElementById('yummy-photo-url');
    const status      = document.getElementById('yummy-status');

    if (!fileInput) return;

    // File selected
    fileInput.addEventListener('change', function () {
      const file = this.files[0];
      if (!file) return;

      // Validate type
      if (!file.type.startsWith('image/')) {
        setStatus(status, 'Please select an image file.', 'error');
        return;
      }

      // Validate size
      if (file.size > MAX_MB * 1024 * 1024) {
        setStatus(status, 'File is too large. Max ' + MAX_MB + ' MB allowed.', 'error');
        return;
      }

      // Show filename + preview
      if (filename) filename.textContent = file.name;
      const reader = new FileReader();
      reader.onload = function (e) {
        previewImg.src = e.target.result;
        previewWrap.style.display = 'inline-block';
      };
      reader.readAsDataURL(file);

      // Upload to Cloudinary
      uploadToCloudinary(file, { photoUrl, status, fileInput });
    });

    // Remove button
    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        resetUpload({ fileInput, filename, previewWrap, previewImg, photoUrl, status });
      });
    }

    // Prevent "Add to Cart" if photo not uploaded
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        if (!photoUrl.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          setStatus(status, '⚠ Please upload your photo before adding to cart.', 'error');
          fileInput.closest('.yummy-upload').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }
  }

  function uploadToCloudinary(file, { photoUrl, status, fileInput }) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', 'yummy-orders');

    setStatus(status, '⏳ Uploading your photo...', 'uploading');
    fileInput.disabled = true;

    fetch(UPLOAD_URL, { method: 'POST', body: formData })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data.secure_url) throw new Error('No URL returned');
        photoUrl.value = data.secure_url;
        setStatus(status, '✓ Photo uploaded successfully!', 'success');
        fileInput.disabled = false;
      })
      .catch(function (err) {
        console.error('[YummyUpload]', err);
        photoUrl.value = '';
        setStatus(status, '✗ Upload failed. Please try again.', 'error');
        fileInput.disabled = false;
      });
  }

  function resetUpload({ fileInput, filename, previewWrap, previewImg, photoUrl, status }) {
    fileInput.value = '';
    previewImg.src = '';
    photoUrl.value = '';
    if (previewWrap) previewWrap.style.display = 'none';
    if (filename) filename.textContent = 'No file chosen';
    setStatus(status, '', '');
  }

  function setStatus(el, message, type) {
    el.textContent = message;
    el.className = 'yummy-upload__status ' + type;
  }
})();
